import { Box } from "@mui/material";
import { HeroSectionComponent } from "../components/HeroSectionComponent";
import ServiceImage from "../assets/aboutUsHero.webp";
import { textlanguages } from "../data/textOfThePage";
import { useLanguageContext } from "../context/languageContext";
import { capitalizeFirstLetter } from "../helpers/capitalizeFirstLetter";
import AboutSection from "../components/landing/section-about-us/AboutSection";

export const AboutUsPage = () => {
  const { languageSelected } = useLanguageContext();
  const serviceText = textlanguages[languageSelected].header[3].service;
  return (
    <Box>
      <HeroSectionComponent
        image={ServiceImage}
        text={capitalizeFirstLetter(serviceText)}
      />
      <AboutSection />
    </Box>
  );
};
